import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import ElementUI from "element-ui"
import locale from "element-ui/lib/locale/lang/zh-CN"
import "element-ui/lib/theme-chalk/index.css"
import "./assets/css/global.scss"
import { fileUrl } from "@/utils/nav"

Vue.use(ElementUI, { locale })
Vue.prototype.$fileUrl = fileUrl

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app")
